module.exports = __webpack_public_path__ + "static/media/VDWXR1.d6437c93.png";